import {Component, Input} from '@angular/core';
import {TeamServiceProvider} from "../../providers/team-service/team-service";

@Component({
  selector: 'header',
  templateUrl: 'header.html'
})
export class HeaderComponent {

  constructor(
    private teamProvider: TeamServiceProvider,
  ) {
  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts